import {
  ApiBlobGetRequest,
  ApiGetRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
// import { showNotif } from '../../notification';
// import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Piutang',
    title_detail: 'Perincian Piutang Usaha',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Daftar Piutang',
        href: '/adm/fin/penjualan/piutang-usaha',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields: [
      {
        key: 'company',
        label: 'Pelanggan',
      },
      {
        key: 'total_piutang',
        label: 'Debet',
      },
      {
        key: 'total_pembayaran',
        label: 'Piutang Terbayar',
      },
      {
        key: 'saldo_piutang',
        label: 'Saldo Piutang',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_detail: [
      {
        key: 'tgl_invoice',
        label: 'Tanggal',
      },
      {
        key: 'code_invoice',
        label: 'No Invoice',
      },
      {
        key: 'hari30',
        label: '0-30 Hari',
      },
      {
        key: 'hari60',
        label: '30-60 Hari',
      },
      {
        key: 'hari90',
        label: '60-90 Hari',
      },
      {
        key: 'hariup90',
        label: '> 90 Hari',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    id_principle: false,
    form: {},
    detail_payment: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changePiutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListPiutang({ commit, state }, payload = {}) {
    commit('changePiutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/piutang`, params);
      commit('changePiutang', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_piutang.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/piutang`, params);
      commit('changePiutang', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailPiutang({ commit, state }) {
    commit('changePiutang', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(
      `fin/piutang/${data.id_principle}`,
      params
    );
    commit('changePiutang', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getPembayaranPiutang({ commit, state }, payload = null) {
    commit('changePiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `fin/piutang/payment/${data.id_principle}/${payload.invoice_id || ''}`,
      {
        payment_type: payload.payment_type,
      }
    );
    commit('changePiutang', {
      detail_payment: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },
};
